const TpClientInvoiceStatusEnum = {
  Draft: 'Draft',
  Finalized: 'Finalized',
  Paid: 'Paid',
  Cancelled: 'Cancelled',
};

export default TpClientInvoiceStatusEnum;
